import {
  CensusReportList,
  ComplianceObj,
  EmpRoundsReport,
  Filter,
  Patient,
  PatientRoundsReport,
  RawEmpFreq,
  RoundHistory
} from '../../config/interfaces';

/**
 * Store sub context for report data
 */
const ReportContext = {
  searchedPatients: [] as Patient[],
  patientRoundHistory: [] as RoundHistory[],
  employeeRoundHistory: [] as RoundHistory[],
  complianceReport: [] as ComplianceObj[],
  complianceReportFilter: {} as Filter,
  patientSummaryReportFilter: {} as Filter,
  employeeSummaryReportFilter: {} as Filter,
  patientRoundsReport: [] as PatientRoundsReport[],
  totalTableCount: 0,
  currentPatientRoundsReportPage: 1,
  currentCensusReportPage: 1,
  reportSearchQuery: '',
  sortCensusKey: 'date',
  sortRoundsKey: 'roundDate',
  sortRoundsDir: 'desc',
  censusReport: [] as CensusReportList[],
  employeeRoundsReport: [] as EmpRoundsReport[],
  employeeFreqReport: [] as RawEmpFreq[],
  currentEmployeeRoundsReportPage: 1,
  currentEmployeeFreqReportPage: 1,
  sortFreqKey: 'employeeDept',
  sortFreqDir: 'asc',
  loading: false,
  roundsReportFilter: {} as Filter,
  censusReportFilter: {} as Filter,
  isCensusDownload: false,
  frequencyReportFilter: {} as Filter
};

export default ReportContext;
